import './styles/App.css';

function App() {
  return <div></div>;
}

export default App;
